<template>
<div class="tw-h-5 tw-flex tw-items-center">
  <svg v-if="status == 'sending'" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5468_403)">
      <path d="M6.99999 3.5V7L9.33332 8.16666M12.8333 7C12.8333 10.2217 10.2217 12.8333 6.99999 12.8333C3.77833 12.8333 1.16666 10.2217 1.16666 7C1.16666 3.77834 3.77833 1.16666 6.99999 1.16666C10.2217 1.16666 12.8333 3.77834 12.8333 7Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_5468_403">
      <rect width="14" height="14" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  <svg v-if="status == 'sent'" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3333 4L5.99999 11.3333L2.66666 8" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <svg v-if="status == 'read'" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.0833 3.5L4.66667 9.91667L1.75 7M6.125 11.375L9.33333 8.16667L12.5417 4.95833" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <svg v-if="status == 'error'"  width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5468_372)">
      <path d="M6.99999 4.66667V7M6.99999 9.33334H7.00582M12.8333 7C12.8333 10.2217 10.2217 12.8333 6.99999 12.8333C3.77833 12.8333 1.16666 10.2217 1.16666 7C1.16666 3.77834 3.77833 1.16667 6.99999 1.16667C10.2217 1.16667 12.8333 3.77834 12.8333 7Z" stroke="#D92D20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_5468_372">
        <rect width="14" height="14" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</div>
</template>

<script>
export default {
  props: ["status"],
};
</script>
